/* Blackberry — At Origin Quality Specification (tolerance sheet).
   2026-10-08, Arturo: "quisiera que al enviar... avisos de proteccion
   al shipper... como en reportes de calidad al shipper... siempre se
   anexara la hoja de tolerancias" — for Twin River only. Rendered to
   PDF through the same htmlToPdfBlob pipeline every other document in
   this app uses (not a static binary asset) so the one HTML source
   here stays the only thing to edit if the spec ever changes — Arturo
   supplied this HTML specifically "por si funciona mejor" than a
   fixed PDF file. */

import { htmlToPdfBlob } from "../pdfRenderer";

export const BLACKBERRY_SPEC_FILENAME = "Blackberry Spec-At-Origin.pdf";

const BLACKBERRY_SPEC_HTML = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Blackberry — At Origin Quality Specification</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600&display=swap" rel="stylesheet">
<style>
:root{
  --ink:#16141a;
  --ink-2:#4b4553;
  --rule:#d8d4dc;
  --rule-light:#ebe8ee;
  --paper:#ffffff;
  --band:#f6f4f8;
  --plum:#44204d;
  --pass:#1f6b43;
  --pass-bg:#e6f1ea;
  --fail:#b02a1f;
  --fail-bg:#fbe8e5;
  --warn:#9a6410;
  --warn-bg:#fbf1dd;
  --zero:#8a1810;
}
*{box-sizing:border-box;margin:0;padding:0;}
body{
  background:#e9e7ec;
  color:var(--ink);
  font-family:'IBM Plex Sans',system-ui,sans-serif;
  font-size:13px;
  line-height:1.45;
  padding:26px 14px 60px;
  -webkit-font-smoothing:antialiased;
}
.sheet{
  max-width:940px;margin:0 auto;background:var(--paper);
  box-shadow:0 2px 26px rgba(20,16,26,.13);
}

/* HEADER */
header{
  background:var(--ink);color:#fff;
  padding:26px 34px 22px;
}
.kicker{
  font-family:'IBM Plex Mono',monospace;
  font-size:10px;letter-spacing:.26em;text-transform:uppercase;
  color:#bda8c6;margin-bottom:11px;
}
h1{
  font-size:26px;font-weight:600;letter-spacing:-.02em;line-height:1.1;
}
h1 span{display:block;font-weight:400;font-size:16px;color:#cfc4d6;margin-top:5px;letter-spacing:0;}
.hdr-meta{
  margin-top:16px;padding-top:13px;border-top:1px solid rgba(255,255,255,.18);
  display:flex;gap:30px;flex-wrap:wrap;
  font-family:'IBM Plex Mono',monospace;font-size:10.5px;
  letter-spacing:.07em;text-transform:uppercase;color:#bda8c6;
}
.hdr-meta b{color:#fff;font-weight:500;}

.body{padding:0 34px 34px;}

/* SECTION HEADS */
.sec{margin-top:26px;}
.sec-head{
  display:flex;align-items:baseline;gap:10px;
  border-bottom:2px solid var(--ink);padding-bottom:7px;margin-bottom:0;
}
.sec-num{
  font-family:'IBM Plex Mono',monospace;font-size:10px;font-weight:600;
  color:var(--plum);letter-spacing:.1em;
}
.sec-head h2{
  font-size:13px;font-weight:600;letter-spacing:.11em;text-transform:uppercase;
}

/* TABLES */
table{width:100%;border-collapse:collapse;}
th{
  text-align:left;font-family:'IBM Plex Mono',monospace;
  font-size:9.5px;letter-spacing:.11em;text-transform:uppercase;
  font-weight:500;color:var(--ink-2);
  padding:9px 10px;border-bottom:1px solid var(--rule);
  background:var(--band);
}
td{padding:8px 10px;border-bottom:1px solid var(--rule-light);vertical-align:top;}
tr:last-child td{border-bottom:none;}
td.p{width:27%;font-weight:600;}
td.d{color:var(--ink-2);}
td.t{
  width:16%;text-align:right;font-family:'IBM Plex Mono',monospace;
  font-weight:600;font-size:13px;white-space:nowrap;
}
.zero{color:var(--zero);}
.sub{
  display:block;font-weight:400;font-size:11.5px;color:var(--ink-2);
  font-family:'IBM Plex Sans',sans-serif;margin-top:2px;
}

/* group label rows */
tr.grp td{
  background:var(--plum);color:#fff;
  font-family:'IBM Plex Mono',monospace;font-size:9.5px;
  letter-spacing:.14em;text-transform:uppercase;font-weight:500;
  padding:6px 10px;border:none;
}
/* subtotal rows */
tr.sum td{
  background:var(--band);font-weight:600;
  border-top:1px solid var(--rule);border-bottom:1px solid var(--rule);
}
tr.sum td.t{font-size:14px;}
tr.total td{
  background:var(--ink);color:#fff;font-weight:600;
  border:none;
}
tr.total td.t{font-size:15px;color:#fff;}

/* GRADE TABLE */
.grade-wrap{overflow-x:auto;}
table.grade{margin-top:0;}
table.grade th{text-align:center;padding:0;border:none;background:none;}
table.grade th.rowlab{
  text-align:left;background:var(--band);
  padding:9px 10px;border-bottom:1px solid var(--rule);
}
.gh{
  padding:9px 6px;color:#fff;
  font-family:'IBM Plex Mono',monospace;font-size:9.5px;
  letter-spacing:.07em;text-transform:uppercase;font-weight:600;
  line-height:1.3;
}
.gh small{display:block;font-size:8.5px;opacity:.85;letter-spacing:.1em;margin-top:2px;}
.g1{background:var(--pass);}
.g2{background:#2f7d4f;}
.g3{background:#c08a1e;}
.g4{background:#c0562b;}
.g5{background:var(--fail);}
table.grade td{
  text-align:center;font-family:'IBM Plex Mono',monospace;
  font-size:12.5px;font-weight:500;padding:10px 6px;
}
table.grade td.rowlab{
  text-align:left;font-family:'IBM Plex Sans',sans-serif;
  font-size:12px;font-weight:600;width:33%;
}
td.pass-c{background:var(--pass-bg);color:var(--pass);font-weight:600;}
td.fail-c{background:var(--fail-bg);color:var(--fail);}

/* CALLOUTS */
.callout{
  border-left:3px solid var(--zero);background:var(--fail-bg);
  padding:13px 17px;margin-top:14px;
}
.callout .ck{
  font-family:'IBM Plex Mono',monospace;font-size:9.5px;
  letter-spacing:.14em;text-transform:uppercase;color:var(--zero);
  font-weight:600;margin-bottom:5px;
}
.callout p{font-size:12.5px;line-height:1.5;color:var(--ink);}
.callout p+p{margin-top:6px;}
.callout strong{font-weight:600;}

.note{
  border-left:3px solid var(--plum);background:var(--band);
  padding:13px 17px;margin-top:14px;
}
.note .ck{
  font-family:'IBM Plex Mono',monospace;font-size:9.5px;
  letter-spacing:.14em;text-transform:uppercase;color:var(--plum);
  font-weight:600;margin-bottom:5px;
}
.note p{font-size:12.5px;line-height:1.5;color:var(--ink-2);}
.note p+p{margin-top:6px;}
.note strong{color:var(--ink);font-weight:600;}

/* ACCEPT STRIP */
.accept{
  display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-top:14px;
}
.acc{border:1px solid var(--rule);padding:14px 17px;}
.acc.ok{border-left:3px solid var(--pass);}
.acc.no{border-left:3px solid var(--fail);}
.acc .ak{
  font-family:'IBM Plex Mono',monospace;font-size:9.5px;
  letter-spacing:.14em;text-transform:uppercase;font-weight:600;margin-bottom:6px;
}
.acc.ok .ak{color:var(--pass);}
.acc.no .ak{color:var(--fail);}
.acc p{font-size:12.5px;line-height:1.5;color:var(--ink-2);}
.acc strong{color:var(--ink);font-weight:600;}

footer{
  margin-top:30px;padding:16px 34px 22px;border-top:2px solid var(--ink);
  font-family:'IBM Plex Mono',monospace;font-size:10px;
  color:var(--ink-2);letter-spacing:.04em;line-height:1.7;
  display:flex;justify-content:space-between;gap:20px;flex-wrap:wrap;
}

@media(max-width:720px){
  body{padding:0;}
  header{padding:22px 18px 18px;}
  .body{padding:0 18px 24px;}
  .accept{grid-template-columns:1fr;}
  footer{padding:14px 18px 20px;}
}
@media print{
  body{background:#fff;padding:0;font-size:10.5px;}
  .sheet{box-shadow:none;max-width:none;}
  header{padding:18px 20px 14px;}
  .body{padding:0 20px 16px;}
  .sec{margin-top:15px;}
  h1{font-size:21px;}
  td,th{padding:5px 8px;}
  .sec,table,.callout,.note,.accept{break-inside:avoid;}
  header,tr.grp td,tr.total td,.gh,td.pass-c,td.fail-c,.callout,.note,tr.sum td,th{
    -webkit-print-color-adjust:exact;print-color-adjust:exact;
  }
  footer{padding:12px 20px 0;}
}
</style>
</head>
<body>
<div class="sheet">

<header>
  <div class="kicker">Technical Data Sheet · Quality Specification</div>
  <h1>Blackberry — At Origin<span>Receiving tolerances and grade standard · Season 2026/27</span></h1>
  <div class="hdr-meta">
    <span>Species <b>Rubus spp.</b></span>
    <span>Point of assessment <b>At Origin</b></span>
    <span>Revision <b>2026/27</b></span>
  </div>
</header>

<div class="body">

<!-- 01 PRODUCT -->
<section class="sec">
  <div class="sec-head"><span class="sec-num">01</span><h2>Product Characteristics</h2></div>
  <table>
    <tbody>
      <tr>
        <td class="p">Species</td>
        <td class="d" colspan="2">Rubus spp. (blackberry) only.</td>
      </tr>
      <tr>
        <td class="p">Variety</td>
        <td class="d" colspan="2">Approved blackberry varieties only. The variety must appear on the case label and on the bill of lading. Any variety outside the approved list requires written approval from the buyer before packing.</td>
      </tr>
      <tr>
        <td class="p">Size</td>
        <td class="d" colspan="2">14 mm minimum, unless otherwise approved.</td>
      </tr>
      <tr>
        <td class="p">Brix</td>
        <td class="d" colspan="2">≥ 9.0 (lot average).</td>
      </tr>
      <tr>
        <td class="p">Color</td>
        <td class="d" colspan="2">Uniform external black color, consistent across the lot. See appearance tolerances below.</td>
      </tr>
      <tr>
        <td class="p">Grade</td>
        <td class="d" colspan="2">Grade 1 (Very Good) or Grade 2 (Good) per the At Origin tolerances 2026/27. Fruit grading below Good fails this specification.</td>
      </tr>
    </tbody>
  </table>
</section>

<!-- 02 DEFECT TOLERANCES -->
<section class="sec">
  <div class="sec-head"><span class="sec-num">02</span><h2>Defect Tolerances</h2></div>
  <table>
    <thead>
      <tr><th>Defect</th><th>Description</th><th style="text-align:right">Tolerance</th></tr>
    </thead>
    <tbody>
      <tr class="grp"><td colspan="3">Condition (damage)</td></tr>
      <tr>
        <td class="p">Decay</td>
        <td class="d">Anthracnose / Alternaria</td>
        <td class="t zero">0%</td>
      </tr>
      <tr>
        <td class="p">Mold</td>
        <td class="d">Botrytis or any type</td>
        <td class="t zero">0%</td>
      </tr>
      <tr>
        <td class="p">Insect presence / evidence</td>
        <td class="d">Dead or live insects, SWD larvae</td>
        <td class="t zero">0%</td>
      </tr>
      <tr>
        <td class="p">Leaky</td>
        <td class="d">Presence of juice, splitting, bruising, open wounds, over-ripeness</td>
        <td class="t">3%</td>
      </tr>
      <tr>
        <td class="p">Soft</td>
        <td class="d">Excessive over-ripeness or loss of firmness, excessive swollen drupelet</td>
        <td class="t">4%</td>
      </tr>
      <tr>
        <td class="p">Shriveling</td>
        <td class="d">Shriveled drupelets, aged (overmature) fruit, dull shine</td>
        <td class="t">3%</td>
      </tr>
      <tr>
        <td class="p">Red cell</td>
        <td class="d">Individual red drupelets</td>
        <td class="t">3%</td>
      </tr>
      <tr>
        <td class="p">Regression</td>
        <td class="d">Mechanical damage — presence of burgundy to red drupelets</td>
        <td class="t">3%</td>
      </tr>
      <tr class="sum">
        <td class="p" colspan="2">Total condition defects <span class="sub">Mold and decay included</span></td>
        <td class="t">≤ 4%</td>
      </tr>

      <tr class="grp"><td colspan="3">Quality</td></tr>
      <tr>
        <td class="p">White cells</td>
        <td class="d">Underdeveloped individual drupelets (physiological disorder)</td>
        <td class="t">5%</td>
      </tr>
      <tr>
        <td class="p">Red / green or dry tips</td>
        <td class="d">Immature red or green tips, dehydrated drupelets at tip</td>
        <td class="t">5%</td>
      </tr>
      <tr>
        <td class="p">Attached core</td>
        <td class="d">Attached core at stem end, floral remains</td>
        <td class="t">5%</td>
      </tr>
      <tr class="sum">
        <td class="p" colspan="2">Total quality defects</td>
        <td class="t">≤ 5%</td>
      </tr>

      <tr class="total">
        <td class="p" colspan="2" style="color:#fff">Maximum combined total</td>
        <td class="t">8%</td>
      </tr>
    </tbody>
  </table>
</section>

<!-- 03 PACKAGING -->
<section class="sec">
  <div class="sec-head"><span class="sec-num">03</span><h2>Packaging</h2></div>
  <table>
    <tbody>
      <tr>
        <td class="p">Underweight per clamshell</td>
        <td class="d">See Weight and Fill requirements</td>
        <td class="t">Pass / fail</td>
      </tr>
      <tr>
        <td class="p">Wrong or unapproved packaging / label</td>
        <td class="d">—</td>
        <td class="t zero">0%</td>
      </tr>
      <tr>
        <td class="p">Wrong species or variety</td>
        <td class="d">Not on the approved list</td>
        <td class="t zero">0%</td>
      </tr>
    </tbody>
  </table>
  <div class="note">
    <div class="ck">Weight</div>
    <p><strong>Zero underweight tolerance.</strong> Every individual clamshell must meet or exceed the minimum. For full weight requirements, fill tolerance and maximum case weight, see Weight and Fill.</p>
  </div>
</section>

<!-- 04 MOLD -->
<section class="sec">
  <div class="sec-head"><span class="sec-num">04</span><h2>Mold — Zero Tolerance</h2></div>
  <div class="callout">
    <div class="ck">Zero tolerance at pack</div>
    <p><strong>No visible mold in any clamshell at pack.</strong> A single mold find triggers an increased sample size on inspection. Mold present on a pallet can cause that pallet to be refused outright. <strong>Do not pack around it.</strong></p>
    <p>In grading, mold or decay is not allowed in any passing grade — Grade 1 (Very Good) and Grade 2 (Good) both require zero mold and decay.</p>
  </div>
</section>

<!-- 05 GRADE TOLERANCES -->
<section class="sec">
  <div class="sec-head"><span class="sec-num">05</span><h2>At Origin Grade Tolerances 2026/27 · % by count</h2></div>
  <div class="grade-wrap">
  <table class="grade">
    <thead>
      <tr>
        <th class="rowlab">Category</th>
        <th><div class="gh g1">1 — Very Good<small>Pass</small></div></th>
        <th><div class="gh g2">2 — Good<small>Pass</small></div></th>
        <th><div class="gh g3">3 — Fair<small>Fail</small></div></th>
        <th><div class="gh g4">4 — Poor<small>Fail</small></div></th>
        <th><div class="gh g5">5 — Bad<small>Fail</small></div></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="rowlab">Damage — no severe</td>
        <td class="pass-c">0 – 1%</td>
        <td class="pass-c">1.01 – 4%</td>
        <td class="fail-c">4.01 – 8%</td>
        <td class="fail-c">8.01 – 10%</td>
        <td class="fail-c">&gt; 10.01%</td>
      </tr>
      <tr>
        <td class="rowlab">Mold / decay <span class="sub">included in condition</span></td>
        <td class="pass-c">None</td>
        <td class="pass-c">None</td>
        <td class="fail-c">0 – 0.49%</td>
        <td class="fail-c">0.5 – 1%</td>
        <td class="fail-c">&gt; 1.01%</td>
      </tr>
    </tbody>
  </table>
  </div>

  <div class="accept">
    <div class="acc ok">
      <div class="ak">Accepted</div>
      <p>Only <strong>Grade 1 (Very Good)</strong> and <strong>Grade 2 (Good)</strong>. On appearance, only the Very Good column passes — quality defects (color, uniformity) above 5% fail.</p>
    </div>
    <div class="acc no">
      <div class="ak">Rejected</div>
      <p><strong>Grade 3 (Fair), Grade 4 (Poor) and Grade 5 (Bad) fail.</strong> Fruit grading below Good may not ship against this specification.</p>
    </div>
  </div>

  <div class="note">
    <div class="ck">Good arrival at destination</div>
    <p>0% mold and decay · less than 4% condition defects (mold and decay included) · less than 9% quality defects.</p>
  </div>

  <div class="note">
    <div class="ck">Sampling</div>
    <p>Minimum <strong>4 clamshells</strong> drawn from <strong>100% of the pallets</strong> on the load, assessed by the buyer or its third-party partners.</p>
  </div>
</section>

</div>

<footer>
  <span>Blackberry — At Origin Quality Specification · Season 2026/27</span>
  <span>All tolerances expressed as % by count unless otherwise stated</span>
</footer>

</div>
</body>
</html>`;

export async function buildBlackberrySpecAtOriginBlob() {
  return htmlToPdfBlob(BLACKBERRY_SPEC_HTML, { widthPx: 816, scale: 2 });
}
